import * as yup from "yup";

import { AuthService, ClientService } from "../../services";
import {
	BackdropCircularProgress,
	EnhancedButtonPrimeReact,
	EnhancedDialog,
	EnhancedSnackbar,
	IResponse,
	IServerError,
	SingleColumnLayout,
	StandardPanel,
	TwoColumnLayout,
} from "@websential/cosmic-v20";
import { Box, Grid, Typography } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { NewAcocuntSetupValidationSchema, isEmpty } from "./validator";
import React, { useEffect, useMemo, useState } from "react";
import { checkSINValidity, formatDate, scrollPanelFieldsToTop, sortDDLByLabel } from "../../common/Common";
import { setSelectedClient, setSelectedClientName, signInUpdate } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery } from "@tanstack/react-query";

import { BankService } from "../../services/BankService";
import { CountryService } from "../../services/common/CountryService";
import { IAppState } from "../../store/reducers";
import {
	INITIAL_SNACKBAR_DATA,
} from "../../common/constants";
import { NewAcocuntBankInfoSetupFieldsPanel } from "./Panels/NewAcocuntBankInfoSetupFieldsPanel";
import { NewAcocuntIssuerInfoSetupFieldsPanel } from "./Panels/NewAcocuntIssuerInfoSetupFieldsPanel";
import { NewAcocuntPaymentSetupPanel } from "./Panels/NewAcocuntPaymentSetupPanel";
import { NewAcocuntSetupFieldsPanel } from "./Panels/NewAcocuntSetupFieldsPanel";
import { NewAcocuntSetupToolbar } from "./NewAcocuntSetupToolbar";
import { VerifyBankDialogue } from "../VerifyBankDialogue";
import { setSelectedDashboardApisData } from "../../store/actions/dashboardApisDataActions";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

const SINGLE_RECORD_DATA_QUERY_KEY = "client-single-data-record";
const useGetData = (
	companyAccountantName: string | null,
) =>
	useQuery({
		queryKey: [SINGLE_RECORD_DATA_QUERY_KEY, companyAccountantName],
		queryFn: (data) => {
			return AuthService.simpleClientGetByIdIfClientCreatedByUser(companyAccountantName);
		},
		refetchOnWindowFocus: false,
	});


const useGetCountryDDL = () =>
	useQuery({
		queryKey: ["country-ddl"],
		queryFn: () => CountryService.getCountryDDL(),
		refetchOnWindowFocus: false,
	});

// const useGetData = () =>
// 	useQuery({
// 		queryKey: ["account-bank-data"],
// 		queryFn: () => {
// 			return AuthService.getPADAgreenmentBankDetails();
// 		},
// 		refetchOnWindowFocus: false,
// 	});
export interface INewAcocuntSetup { }
export const NewAcocuntSetup: React.FC<INewAcocuntSetup> = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [isPendingData, setIsPendingData] = useState(false);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [defaultSelectedCountryState, setDefaultSelectedCountryState] = useState("")
	const [provinceDDLLoading, setProvinceDDLLoading] = useState(false);
	const [provinceStateDDLinUpdate, setProvinceStateDDLinUpdate] =
		useState(undefined);
	const [cityDDLinUpdate, setCityDDLinUpdate] = useState(undefined);
	const [provinceStateLabelinUpdate, setProvinceStateLabelinUpdate] =
		useState<any>(undefined);
	// [Verify]
	const [bankName, setBankName] = useState(null)
	const [openVerifyBankDialogue, setOpenverifyBankDialogue] = useState(false)

	const { isPending: isPendingCoutryDDL, data: countryList } = useGetCountryDDL();
	// const { isPending, data: accOrBankDetailsData }: any = useGetData();

	// useEffect(() => {
	// 	if (accOrBankDetailsData) {
	// 		// formMethods.setValue(
	// 		// 	"transactionAlertEmail",
	// 		// 	accOrBankDetailsData?.transactionAlertEmail ?? undefined
	// 		// );
	// 	}
	// }, [accOrBankDetailsData])



	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const userIdStore = useSelector((state: IAppState) => state.user.profile.userId);
	const userEmail = useSelector((state: IAppState) => state.user.profile.email);
	const companyAccountantName = useSelector(
		(state: IAppState) => state.user.profile.companyAccountantName
	);
	const companySequenceNumber = useSelector(
		(state: IAppState) => state.user.profile.companySequenceNumber
	);
	const lastBankScreen = useSelector(
		(state: IAppState) => state.user.profile.lastBankScreen
	);
	useEffect(() => {
		if (companyAccountantName !== null && isAdminUser === 200) {
			formMethods.setValue('legalName', companyAccountantName)
		}
	}, [companyAccountantName])

	const { isPending: isPendingById, data: selectedDataRecord } = useGetData(
		companyAccountantName
	);

	useEffect(() => {
		console.log('selectedDataRecord', selectedDataRecord)
		if (selectedDataRecord && selectedDataRecord.clientDetails) {
			Object.keys(selectedDataRecord.clientDetails).forEach((fieldName) => {
				// @ts-ignore
				const fieldValue = selectedDataRecord.clientDetails[fieldName];
				// @ts-ignore
				formMethods.setValue(fieldName, fieldValue ?? undefined);
				if (fieldName === "address") {
					Object.keys(fieldValue).forEach((objFieldName) => {
						const objFieldValue = fieldValue[objFieldName];
						formMethods.setValue(objFieldName, objFieldValue ?? undefined);
						if (objFieldName === "countryType") {
							(async () => {
								try {
									setProvinceDDLLoading(true);
									const responce = await AuthService.getProvinceOrStateDDL(
										selectedDataRecord.clientDetails.address.country.id,
										objFieldValue ? "province" : "state"
									);

									setProvinceStateDDLinUpdate(responce);
									setProvinceStateLabelinUpdate(
										objFieldValue ? "province" : "state"
									);
								} catch {

								} finally {
									setProvinceDDLLoading(false);
								}
							})();
						}
						if (objFieldName === "country") {
							formMethods.setValue(objFieldName, objFieldValue.id ?? undefined);
						}
						if (objFieldName === "province") {
							formMethods.setValue(objFieldName, objFieldValue.id ?? undefined);
							(async () => {
								try {
									setProvinceDDLLoading(true);
									const responce = await AuthService.getCityDDL(
										objFieldValue.id
									);

									setCityDDLinUpdate(responce);
								} catch {

									setProvinceDDLLoading(false);
								} finally {
									setProvinceDDLLoading(false);
								}
							})();
						}
						if (objFieldName === "state") {
							formMethods.setValue(objFieldName, objFieldValue.id ?? undefined);
						}
						if (objFieldName === "city") {
							formMethods.setValue(objFieldName, objFieldValue.id ?? undefined);
						}
					});
				}
				if (fieldName === "scheduleStartDate") {
					if (fieldValue !== null) {
						const defaultDate = new Date(fieldValue);

						formMethods.setValue(fieldName, defaultDate);
					} else {
						formMethods.setValue(fieldName, fieldValue);
					}
				}
				if (fieldName === "billingStartDate") {
					if (fieldValue !== null) {
						const defaultDate = new Date(fieldValue);

						formMethods.setValue(fieldName, defaultDate);
					} else {
						formMethods.setValue(fieldName, fieldValue);
					}
				}
			});
		}
		if (selectedDataRecord && selectedDataRecord.filingResource) {
			Object.keys(selectedDataRecord.filingResource).forEach((fieldName: any) => {
				const fieldValue = selectedDataRecord.filingResource[fieldName]
				formMethods.setValue(fieldName, fieldValue);
				if (fieldName === "ownerSin1") {
					const formattedNumber = fieldValue
						? fieldValue.replace(/(\d{3})(\d{3})(\d{3})/, "$1-$2-$3")
						: undefined;
					formMethods.setValue("ownerSin1", formattedNumber);
				}
				if (fieldName === "phone1") {
					const formattedNumber = fieldValue
						? fieldValue.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")
						: undefined;
					formMethods.setValue("phone1", formattedNumber);
				}
			})
		}
		if (selectedDataRecord && selectedDataRecord.clientBank) {
			Object.keys(selectedDataRecord.clientBank).forEach((fieldName: any) => {
				const fieldValue = selectedDataRecord.clientBank[fieldName]
				formMethods.setValue(fieldName, fieldValue);
			})
		}
	}, [selectedDataRecord]);

	const { isPending: isSubmitting, mutate: saveNewAcocuntSetupFieldsData } =
		useMutation({
			mutationFn: AuthService.saveNewAccountDetails,
			onSuccess: (res: IServerError | IResponse | any) => {
				if (res.status === 200 || res.status === 201) {
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// let path = `/account-bank-details`;
					// navigate(path);
					dispatch(setSelectedClient({ id: res.data.id, legalName: res.data.legalName }));
					dispatch(setSelectedClientName({ clientName: res.data.legalName }));
					dispatch(setSelectedDashboardApisData({ client_detail: res.data }));

					const [
						firstName,
						lastName,
						ownerSin1,
						nonResident,
						phone1,
						ext
					] = formMethods.watch([
						"firstName",
						"lastName",
						"ownerSin1",
						"nonResident",
						"phone1",
						"ext"
					]);
					const issuerPayload = {
						id: selectedDataRecord && selectedDataRecord.filingResource ? selectedDataRecord.filingResource.id : undefined,
						clientId: res.data.id,
						effectiveFromYear: new Date(res.data.scheduleStartDate).getFullYear(),
						role: ["6173ddf7-68e2-426f-b1be-9d1dd63eb49d"],
						firstName: firstName ?? undefined,
						lastName: lastName ?? undefined,
						nonResident: nonResident ?? undefined,
						ownerSin1: ownerSin1 && ownerSin1 !== "" ? ownerSin1.replace(/-/g, "") : undefined,
						phone1: phone1.replace(/\D/g, "") ?? undefined,
						ext: ext ?? undefined,

					};
					// if (firstName && firstName !== null && firstName !== "") {
					saveIssuerDataFieldsData(issuerPayload);
					// }


				} else {
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong!",
						severity: "error",
					});
				}
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const { isPending: isSubmittingIssuerData, mutate: saveIssuerDataFieldsData } =
		useMutation({
			mutationFn: AuthService.saveIssuerData,
			onSuccess: async (res: IServerError | IResponse | any) => {
				// if (res.status === 200 || res.status === 201) {
				// 	setSnackbarData({
				// 		open: true,
				// 		message: "Success",
				// 		severity: "success",
				// 	});
				// 	// let path = `/account-bank-details`;
				// 	// navigate(path);
				// 	scrollPanelFieldsToTop();
				// 	const [
				// 		accountNo,
				// 		branchTransitNumber,
				// 		bankFinancialNo,
				// 	] = formMethods.watch([
				// 		"accountNo",
				// 		"branchTransitNumber",
				// 		"bankFinancialNo",
				// 	]);
				// 	const bankPayload = {
				// 		id: selectedDataRecord && selectedDataRecord.clientBank ? selectedDataRecord.clientBank.id : undefined,
				// 		clientId: res.data.clientId,
				// 		// name: bankName,
				// 		accountNo: accountNo ?? undefined,
				// 		branchTransitNumber: branchTransitNumber ?? undefined,
				// 		bankFinancialNo: bankFinancialNo ?? undefined,
				// 		primaryAccount: false,
				// 		status: 200

				// 	};
				// 	if (accountNo && accountNo !== null && accountNo !== "") {
				// 		saveBankDetailsFieldsData(bankPayload);
				// 	}  else {
				// 		scrollPanelFieldsToTop();
				// 		(async () => {
				// 			try {
				// 				setIsPendingData(true)
				// 				const response = await AuthService.lastBankScreen(userIdStore, 300);  //Client Dashboard
				// 				dispatch(
				// 					signInUpdate({
				// 						user: { companyAccountantName: null, lastBankScreen: 300 },
				// 					})
				// 				);
				// 			} catch { setIsPendingData(false) } finally { setIsPendingData(false) }
				// 		})();
				// 	}
				// } else {
				// 	setSnackbarData({
				// 		open: true,
				// 		message: res.message ? res.message : "Something went wrong!",
				// 		severity: "error",
				// 	});
				// }

				if (res.status !== 200 && res.status !== 201) {
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong!",
						severity: "error",
					});
					return;
				}

				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
				scrollPanelFieldsToTop();

				const [accountNo, branchTransitNumber, bankFinancialNo] = formMethods.watch([
					"accountNo",
					"branchTransitNumber",
					"bankFinancialNo",
				]);

				const isBankFieldEmpty = (value: string | null) => value === null || value === "" || !value;

				const goToClientDashboard = async () => {
					try {
						setIsPendingData(true);
						await AuthService.lastBankScreen(userIdStore, 300); // Client Dashboard
						dispatch(
							signInUpdate({
								user: { companyAccountantName: null, lastBankScreen: 300 },
							}),
						);
					} catch (error) {
						console.error("Failed to update last bank screen:", error);
					} finally {
						setIsPendingData(false);
					}
				};

				if (!isBankFieldEmpty(accountNo)) {
					// User has an account number — save/update bank details
					const bankPayload = {
						id: selectedDataRecord?.clientBank?.id ?? undefined,
						clientId: res.data.clientId,
						accountNo: accountNo ?? undefined,
						branchTransitNumber: branchTransitNumber ?? undefined,
						bankFinancialNo: bankFinancialNo ?? undefined,
						primaryAccount: false,
						status: 200,
					};
					saveBankDetailsFieldsData(bankPayload);
					return;
				}

				const shouldDeleteClientBank =
					companyAccountantName === null &&
					selectedDataRecord?.clientBank &&
					(isBankFieldEmpty(accountNo) ||
						isBankFieldEmpty(branchTransitNumber) ||
						isBankFieldEmpty(bankFinancialNo));

				if (shouldDeleteClientBank) {
					try {
						setIsPendingData(true);
						await AuthService.deleteClientBankById(selectedDataRecord.clientBank.id);
					} catch (error) {
						console.error("Failed to delete client bank:", error);
						setIsPendingData(false);
						return; // don't proceed to lastBankScreen if delete failed
					}
					await goToClientDashboard();
					return;
				}

				await goToClientDashboard();
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});
	const { isPending: isSubmittingBankDetails, mutate: saveBankDetailsFieldsData } =
		useMutation({
			mutationFn: AuthService.saveClientBankDetails,
			onSuccess: (res: IServerError | IResponse | any) => {
				if (res.status === 200 || res.status === 201) {
					setSnackbarData({
						open: true,
						message: "Success",
						severity: "success",
					});
					// let path = `/account-bank-details`;
					// navigate(path);
					scrollPanelFieldsToTop();
					if (lastBankScreen && lastBankScreen !== 300) {
						(async () => {
							try {
								setIsPendingData(true)
								const response = await AuthService.lastBankScreen(userIdStore, 100);  //PAD

							} catch { setIsPendingData(false) } finally { setIsPendingData(false) }
						})();
						dispatch(
							signInUpdate({
								user: { companyAccountantName: null },
							})
						);
						dispatch(
							signInUpdate({
								user: { lastBankScreen: 100 },
							})
						);
					}
				} else {
					setSnackbarData({
						open: true,
						message: res.message ? res.message : "Something went wrong!",
						severity: "error",
					});
				}
			},
			onError: () => {
				// TODO: customize the toast message based on the response
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			},
		});

	const DEFAULT_VALUES = {
		legalName: undefined,
		operatingName: undefined,
		addressLine1: undefined,
		// country: undefined,
		province: undefined,
		postCode: undefined,
		phone: undefined,
		craBusinessNo: undefined,
		scheduleStartDate: null,

		// Bank
		paymentSetup: 200,
		accountNo: undefined,
		branchTransitNumber: undefined,
		bankFinancialNo: undefined,

		// Issuer
		firstName: undefined,
		lastName: undefined,
		nonResident: false,
		ownerSin1: undefined,
		phone1: undefined,
		ext: undefined,
	};

	const ExtendedValidationSchema = NewAcocuntSetupValidationSchema.shape({
		postCode: yup.string().when("country", (country: any, schema: any) => {

			const selectedCountry = countryList.find(
				(c: any) => c.value === country[0]
			);

			if (selectedCountry?.shortCode === "CAN") {
				return schema
					.required("Postal Code is required")
					.length(6, "Postal Code must be exactly 6 characters");
			}
			return schema; // Unchanged for other countries
		}),
		zipCode: yup.string().when("country", (country: any, schema: any) => {
			const selectedCountry = countryList.find(
				(c: any) => c.value === country[0]
			);
			if (selectedCountry?.shortCode === "USA") {
				return schema
					.required("Zip Code is required")
					.length(5, "Zip Code must be exactly 5 characters");
			}
			return schema; // Unchanged for other countries
		}),
		ownerSin1: yup
			.string()
			// .nullable()
			.test(
				"ownerSin1-test",
				"Invalid Social Insurance Number",
				function (value: any) {
					const { nonResident } = this.parent; // 👈 get from form context

					// // If nonResident is false, field is required
					// if (!nonResident && !value) {
					// 	return this.createError({
					// 		message: "Social Insurance Number is required",
					// 	});
					// }
					// ✅ If nonResident, skip all validations
					if (nonResident) {
						return true;
					}


					// If nullable (no value), skip validity check
					if (!value) {
						return this.createError({
							message: "Social Insurance Number is required",
						});
					}

					// Always check SIN validity when value exists
					const sin = value.replace(/-/g, "");
					const output = checkSINValidity(sin);
					const maxLength = value.charAt(2) === "*" ? 7 : 11;

					if (
						value.length === maxLength &&
						(value.charAt(2) === "*" || output % 10 === 0)
					) {
						return true;
					}

					return this.createError({
						message: "Invalid Social Insurance Number",
					});
				},
			),
		accountNo: yup
			.string()
			.nullable()
			.test(
				"bank-fields-required",
				"Bank Account No. is required",
				function (value) {
					const { paymentSetup } = this.parent;

					// If paymentSetup is 200, accountNo is required
					if (paymentSetup === "200" && !value) {
						return this.createError({
							message: "Bank Account No. is required",
						});
					} else if (paymentSetup === 200 && !value) {
						return this.createError({
							message: "Bank Account No. is required",
						});
					}

					// Otherwise nullable, skip
					return true;
				},
			),
		branchTransitNumber: yup
			.string()
			.nullable()
			.test(
				"bank-fields-required",
				"Branch / Transit No. is required",
				function (value) {
					const { paymentSetup } = this.parent;

					// If paymentSetup is 200, accountNo is required
					if (paymentSetup === "200" && !value) {
						return this.createError({
							message: "Branch / Transit No. is required",
						});
					} else if (paymentSetup === 200 && !value) {
						return this.createError({
							message: "Branch / Transit No. is required",
						});
					}

					// Otherwise nullable, skip
					return true;
				},
			),
		bankFinancialNo: yup
			.string()
			.nullable()
			.test(
				"bank-fields-required",
				"Bank / Fin Institution No. is required",
				function (value) {
					const { paymentSetup } = this.parent;

					// If paymentSetup is 200, accountNo is required
					if (paymentSetup === "200" && !value) {
						return this.createError({
							message: "Bank / Fin Institution No. is required",
						});
					} else if (paymentSetup === 200 && !value) {
						return this.createError({
							message: "Bank / Fin Institution No. is required",
						});
					}

					// Otherwise nullable, skip
					return true;
				},
			),
		scheduleStartDate: yup
			.string()
			.required("Schedule Start Date is required"),
	});

	const formMethods = useForm<any>({
		resolver: yupResolver(ExtendedValidationSchema),
		mode: "onBlur",
		reValidateMode: "onChange",
		defaultValues: DEFAULT_VALUES
	});

	const [openBranchAddedDialog, setOpenBranchAddedDialog] = useState(false);
	const [pendingValues, setPendingValues] = useState<any>(null);
	const onCloseBranchAddedHandler = () => {
		setOpenBranchAddedDialog(false)
	}
	const onConfirmBranchSubmit = async () => {
		if (pendingValues) {
			setOpenBranchAddedDialog(false);
			setPendingValues(null);
			const SelectedCountry = countryList.find(
				(e: any) => e.value === pendingValues.country
			);
			try {
				setIsPendingData(true);
				const ProvinceOrStateDDL = await AuthService.getProvinceOrStateDDL(
					SelectedCountry.value,
					SelectedCountry.countryType
				);
				const selectedProvinceOrState = pendingValues.province
					? ProvinceOrStateDDL.find((e: any) => e.value === pendingValues.province)
					: pendingValues.state
						? ProvinceOrStateDDL.find((e: any) => e.value === pendingValues.state)
						: undefined;

				let payload = {
					id: selectedDataRecord && selectedDataRecord.clientDetails ? selectedDataRecord.clientDetails.id : undefined,
					legalName: pendingValues.legalName,
					operatingName: pendingValues.firstName,
					paymentSetup: Number(pendingValues.paymentSetup),
					address: {
						countryType: pendingValues.province ? true : false,
						country: {
							id: SelectedCountry.value,
							name: SelectedCountry.label,
							shortCode: SelectedCountry.shortCode,
						},
						province: pendingValues.province
							? {
								id: selectedProvinceOrState.value,
								name: selectedProvinceOrState.label,
								shortCode: selectedProvinceOrState.shortCode,
							}
							: undefined,
						states: pendingValues.state
							? {
								id: selectedProvinceOrState.value,
								name: selectedProvinceOrState.label,
								shortCode: selectedProvinceOrState.shortCode,
							}
							: undefined,
						addressLine1: pendingValues.addressLine1,
						city: pendingValues.city,
						postCode: pendingValues.postCode
							? pendingValues.postCode.replace(/[a-z]/g, (match: string) =>
								match.toUpperCase()
							)
							: undefined,
						zipCode: pendingValues.zipCode ? pendingValues.zipCode : undefined,
						phone: pendingValues.phone,
					},
					craBusinessNo: pendingValues.craBusinessNo,
					scheduleStartDate: formatDate(pendingValues.scheduleStartDate),
					status:
						Number(pendingValues.paymentSetup) !== 200 ? 100 : 200,
					billingStartDate: formatDate(new Date()),
					systemAlertsFrom: userEmail
				};
				saveNewAcocuntSetupFieldsData(payload);
			} catch {
			} finally {
				setIsPendingData(false);
			}
		}
	};

	const onSubmit = async (values: any) => {
		if (values.accountNo && values.accountNo !== null && values.accountNo !== "") {
			try {
				setIsPendingData(true)
				const verifyBank = await BankService.bankOrBranchExists(values.bankFinancialNo, values.branchTransitNumber);
				console.log("verifyBank", verifyBank)
				setBankName(verifyBank.bankName)
				if (verifyBank && verifyBank.bankExist && verifyBank.branchExist) {

					const SelectedCountry = countryList.find(
						(e: any) => e.value === values.country
					);
					try {
						setIsPendingData(true);
						const ProvinceOrStateDDL = await AuthService.getProvinceOrStateDDL(
							SelectedCountry.value,
							SelectedCountry.countryType
						);
						const selectedProvinceOrState = values.province
							? ProvinceOrStateDDL.find((e: any) => e.value === values.province)
							: values.state
								? ProvinceOrStateDDL.find((e: any) => e.value === values.state)
								: undefined;

						let payload = {
							id: selectedDataRecord && selectedDataRecord.clientDetails ? selectedDataRecord.clientDetails.id : undefined,
							legalName: values.legalName,
							operatingName: values.firstName,
							paymentSetup: Number(values.paymentSetup),
							address: {
								countryType: values.province ? true : false,
								country: {
									id: SelectedCountry.value,
									name: SelectedCountry.label,
									shortCode: SelectedCountry.shortCode,
								},
								province: values.province
									? {
										id: selectedProvinceOrState.value,
										name: selectedProvinceOrState.label,
										shortCode: selectedProvinceOrState.shortCode,
									}
									: undefined,
								states: values.state
									? {
										id: selectedProvinceOrState.value,
										name: selectedProvinceOrState.label,
										shortCode: selectedProvinceOrState.shortCode,
									}
									: undefined,
								addressLine1: values.addressLine1,
								city: values.city,
								postCode: values.postCode
									? values.postCode.replace(/[a-z]/g, (match: string) =>
										match.toUpperCase()
									)
									: undefined,
								zipCode: values.zipCode ? values.zipCode : undefined,
								phone: values.phone,
							},
							craBusinessNo: values.craBusinessNo,
							scheduleStartDate: formatDate(values.scheduleStartDate),
							status:
								Number(values.paymentSetup) !== 200 ? 100 : 200,
							billingStartDate: formatDate(new Date()),
							systemAlertsFrom: userEmail
						};
						saveNewAcocuntSetupFieldsData(payload);
					} catch {
					} finally {
						setIsPendingData(false);
					}


				}
				if (verifyBank && !verifyBank.bankExist) {
					setSnackbarData({
						open: true,
						message: "Bank does not exist",
						severity: "error"
					})
				}
				if (verifyBank && verifyBank.bankExist && !verifyBank.branchExist) {
					setPendingValues(values);
					setOpenBranchAddedDialog(true);
				}

				setIsPendingData(false)
			}
			catch { setIsPendingData(false) }
		} else {
			const SelectedCountry = countryList.find(
				(e: any) => e.value === values.country
			);
			try {
				setIsPendingData(true);
				const ProvinceOrStateDDL = await AuthService.getProvinceOrStateDDL(
					SelectedCountry.value,
					SelectedCountry.countryType
				);
				const selectedProvinceOrState = values.province
					? ProvinceOrStateDDL.find((e: any) => e.value === values.province)
					: values.state
						? ProvinceOrStateDDL.find((e: any) => e.value === values.state)
						: undefined;

				let payload = {
					id: selectedDataRecord && selectedDataRecord.clientDetails ? selectedDataRecord.clientDetails.id : undefined,
					legalName: values.legalName,
					operatingName: values.firstName,
					paymentSetup: Number(values.paymentSetup),
					address: {
						countryType: values.province ? true : false,
						country: {
							id: SelectedCountry.value,
							name: SelectedCountry.label,
							shortCode: SelectedCountry.shortCode,
						},
						province: values.province
							? {
								id: selectedProvinceOrState.value,
								name: selectedProvinceOrState.label,
								shortCode: selectedProvinceOrState.shortCode,
							}
							: undefined,
						states: values.state
							? {
								id: selectedProvinceOrState.value,
								name: selectedProvinceOrState.label,
								shortCode: selectedProvinceOrState.shortCode,
							}
							: undefined,
						addressLine1: values.addressLine1,
						city: values.city,
						postCode: values.postCode
							? values.postCode.replace(/[a-z]/g, (match: string) =>
								match.toUpperCase()
							)
							: undefined,
						zipCode: values.zipCode ? values.zipCode : undefined,
						phone: values.phone,
					},
					craBusinessNo: values.craBusinessNo,
					scheduleStartDate: formatDate(values.scheduleStartDate),
					status:
						Number(values.paymentSetup) !== 200 ? 100 : 200,
					billingStartDate: formatDate(new Date()),
					systemAlertsFrom: userEmail
				};
				saveNewAcocuntSetupFieldsData(payload);
			} catch {
			} finally {
				setIsPendingData(false);
			}
		}
	};

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const onResetClicked = () => {
		setSnackbarData({
			open: true,
			message: "Success",
			severity: "success",
		});
		formMethods.reset();
		formMethods.setValue('legalName', companyAccountantName)
		formMethods.setValue("country", defaultSelectedCountryState)
		scrollPanelFieldsToTop();
	};

	return (
		<Grid>
			<BackdropCircularProgress
				open={isSubmitting || isPendingData || isPendingCoutryDDL || isSubmittingBankDetails || isSubmittingIssuerData || isPendingById || provinceDDLLoading}
				testId="yooo"
			/>
			<FormProvider {...formMethods}>
				<form onSubmit={formMethods.handleSubmit(onSubmit)}>
					<Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
						<Grid size={{ xs: 12, sm: 12, md: 8, lg: 8, xl: 8 }} sx={{ paddingTop: "1rem" }}>
							<TwoColumnLayout
								toolbar={
									<></>
								}
								leftColumnContent={
									<>
										<StandardPanel
											title="Company"
											testId={`company`}
											variant="outlined"
											borderHide={true}
										>
											<NewAcocuntSetupFieldsPanel
												formMethods={formMethods}
												countryList={countryList}
												isLoadingData={(value: boolean) => setIsPendingData(value)}
												setDefaultSelectedCountry={(selectedCountry: any) => setDefaultSelectedCountryState(selectedCountry)}
												companySequenceNumber={companySequenceNumber}
												provinceStateLabelinUpdate={
													provinceStateLabelinUpdate &&
													provinceStateLabelinUpdate
												}
												provinceStateDDLinUpdate={
													provinceStateDDLinUpdate && provinceStateDDLinUpdate
												}
												cityDDLinUpdate={cityDDLinUpdate && sortDDLByLabel(cityDDLinUpdate)}
											/>
										</StandardPanel>

									</>
								}
								rightColumnContent={
									<>
										<StandardPanel
											title="Payment Setup"
											testId={`payment-setup`}
											variant="outlined"
											borderHide={true}
										>
											<NewAcocuntPaymentSetupPanel formMethods={formMethods} />
										</StandardPanel>
										<StandardPanel
											title="Bank Information"
											testId={`bank-details`}
											variant="outlined"
											borderHide={true}
											borderBottom={true}
										>
											<NewAcocuntBankInfoSetupFieldsPanel
												onVerifyBankClickedHandler={() => setOpenverifyBankDialogue(true)}
											/>
										</StandardPanel>
										<StandardPanel
											title="Owner/Contact Issuer"
											testId={`issuer`}
											variant="outlined"
											borderHide={true}
										>
											<NewAcocuntIssuerInfoSetupFieldsPanel formMethods={formMethods} />
										</StandardPanel>
									</>
								}
								testId="t4-slip-setup-form"
								showToolbar={false}
							/>
							<NewAcocuntSetupToolbar
								isSubmitting={false} onResetClickHandler={onResetClicked}
							/>
						</Grid>
					</Grid>
				</form>
			</FormProvider>
			<VerifyBankDialogue openVerifyBankDialogue={openVerifyBankDialogue} setOpenVerifyBankDialogue={(value: any) => setOpenverifyBankDialogue(value)} parentFormMethods={formMethods} />
			<EnhancedDialog
				dialogTitle="Please Confirm"
				key="dialog-box"
				testId="dialog"
				onCloseHandler={onCloseBranchAddedHandler}
				open={openBranchAddedDialog}
				dialogContent={
					<Box>
						<Typography variant="body2" sx={{ mb: 2 }}>
							Account 1 Branch / Transit No. is not a valid code as listed in our current banking records. If you believe this is correct, please mail us.
						</Typography>
						<Typography variant="body2">
							Note: Penalty amount will be deducted for providing incorrect bank details.
						</Typography>
					</Box>
				}
				showdividers={false}
				dialogAction={
					<Grid>
						<EnhancedButtonPrimeReact
							label="Cancel"
							severity="secondary"
							text
							raised
							onClickHandler={onCloseBranchAddedHandler}
							style={{ fontSize: "small" }}
						/>
						<EnhancedButtonPrimeReact
							label="Ok"
							severity="success"
							raised
							onClickHandler={onConfirmBranchSubmit}
							style={{ marginLeft: "16px", fontSize: "small" }}
						/>
					</Grid>
				}
			/>
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"security-questions-snackbar"}
				open={snackbarData.open}
			/>
		</Grid>
	);
};
